import React, { useEffect } from 'react';

interface Props {
  message: string | null;
  onClear: () => void;
  autoHideMs?: number;
  variant?: 'info' | 'success';
}

const GatheringInfoToast: React.FC<Props> = ({
  message,
  onClear,
  autoHideMs = 6000,
  variant = 'info',
}) => {
  useEffect(() => {
    if (!message) return;
    const id = window.setTimeout(onClear, autoHideMs);
    return () => window.clearTimeout(id);
  }, [message, onClear, autoHideMs]);

  if (!message) return null;

  const tone =
    variant === 'success'
      ? 'border-emerald-200 bg-emerald-50 text-emerald-900'
      : 'border-indigo-200 bg-indigo-50 text-indigo-900';

  return (
    <div className="pointer-events-none fixed right-6 top-20 z-[15000] animate-in fade-in slide-in-from-top-2 duration-300">
      <div className={`rounded-lg border px-4 py-3 text-sm font-medium shadow-lg max-w-md ${tone}`}>
        {message}
      </div>
    </div>
  );
};

export default GatheringInfoToast;
